"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACCOUNTING_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ACCOUNTING_INTEGRATION;
  }
});
Object.defineProperty(exports, "CRM", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CRM;
  }
});
Object.defineProperty(exports, "FINANCIAL_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FINANCIAL_MANAGEMENT;
  }
});
Object.defineProperty(exports, "HR_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.HR_MANAGEMENT;
  }
});
Object.defineProperty(exports, "INVENTORY_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INVENTORY_MANAGEMENT;
  }
});
Object.defineProperty(exports, "MANUFACTURING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MANUFACTURING;
  }
});
Object.defineProperty(exports, "ORDER_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ORDER_MANAGEMENT;
  }
});
Object.defineProperty(exports, "PURCHASING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PURCHASING;
  }
});
Object.defineProperty(exports, "SALES_MARKETING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SALES_MARKETING;
  }
});
Object.defineProperty(exports, "SUPPLY_CHAIN_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SUPPLY_CHAIN_MANAGEMENT;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/ERP.js
// module id = 569
// module chunks = 209 210 211 212 213